import React from 'react';
import { SubmitButton } from './submit-button';
import { CancelButton } from './cancel-button';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ActionsSection(props: any) {
  return (
    <div className="actions">
      <SubmitButton disabled={props.disabled} isNew={props.isNew} />
      <CancelButton disabled={props.disabled} onCancel={props.onCancel} />
    </div>
  );
}
